
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/[classificationUrlId]",
      function () {
        return require("private-next-pages/article/[classificationUrlId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/[classificationUrlId]"])
      });
    }
  